import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { EN, LANGUAGE_LIST } from '@/utils/constants';

export const useAcceptedLanguage = () => {
  const { i18n } = useTranslation();
  const browserLanguage = navigator.language;
  const acceptedLanguageValues = LANGUAGE_LIST.map((language) => language.value);
  // strip the country code from the browser language to compare with accepted language values
  const strippedBrowserLanguage = browserLanguage.split('-')[0].toUpperCase();

  useEffect(() => {
    if (!acceptedLanguageValues.includes(strippedBrowserLanguage)) {
      i18n.changeLanguage(EN);
    }
  }, []);
};
